import { useEffect } from "react";
import { useCallback } from "react";
import { useState } from "react";

// const position = [35.723822, 51.407067];
// const zoom = 13;
// const DisplayPosition = (props) => {
//   const [position, setPosition] = useState(() => props.map.getCenter());

//   const onMove = useCallback((props) => {
//     setPosition(props.map.getCenter());
//     let mapLocation = `${position.lat.toFixed(6)},${position.lng.toFixed(6)}`;
//     if ("HasManyInputData" in props) {
//       props.HasManyInputData(props.index, props.HasManyKey, mapLocation);
//     } else {
//       let object = props.inputData;
//       object[props.item.key] = mapLocation;
//       props.setInputData(object);
//     }
//   }, [props.map, props.inputData, props.item, position.lat, position.lng, props.setInputData]);

//   useEffect(() => {
//     props.map.on("move", onMove);

//     return () => {
//       props.map.off("move", onMove);
//     };
//   }, [props.map, onMove]);
// }

// export default DisplayPosition;
function DisplayPosition(props) {
  const { map, inputData, item, setInputData } = props
  const [position, setPosition] = useState(() => map.getCenter());

  const onMove = useCallback(() => {
    setPosition(map.getCenter());
    let mapLocation = `${position.lat.toFixed(6)},${position.lng.toFixed(6)}`;
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, mapLocation);
    } else {
      let object = inputData;
      object[item.key] = mapLocation;
      setInputData(object);
    }
  }, [map, inputData, item, position.lat, position.lng, setInputData]);

  useEffect(() => {
    map.invalidateSize(true);
    map.on("move", onMove);
    return () => {
      map.off("move", onMove);
    };
  }, [map, onMove]);
}

export default DisplayPosition;
